export class ChargeVerificationSaveError extends Error {
  constructor(cause: unknown) {
    super('The charge verification setting could not be saved', { cause });
    this.name = 'ChargeVerificationSaveError';
  }
}
